import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request).pipe(
         catchError((error: HttpErrorResponse) => {
            let errorMessage = '';
    
            if (error.error instanceof ErrorEvent) {
              // Si es un error del cliente (como un error de red), se muestra en la consola del navegador
              errorMessage = `Error: ${error.error.message}`;
            } else {
              // Si es un error del servidor, se muestra el mensaje de error recibido del servidor
              errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
            }
    
            console.error(errorMessage);
    
            // Devuelve un Observable con el error para que se pueda manejar en el componente
            return throwError(errorMessage);
          })
      );
   }
}
